import DoccenLibrary from '@/components/elements/doccen-lib/library';
import { useSEO } from '@/hooks/useSEO';
import { useTab } from '@/hooks/useTab';
import useToast from '@/hooks/useToast';
import useToggle from '@/hooks/useToggle';
import { ELibraryTabKey } from '@/interfaces/doccen-lib/library.interface';
import cookieCommons from 'common/cookieCommons';
import { PATH_NAME } from 'configs/pathName';
import { TabDataProps, Tabs } from 'design-system/components/Tabs';
import BaseLayout from 'layouts';
import { GetServerSidePropsContext } from 'next';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { memo } from 'react';
import { NextPageWithLayout } from '../page';

const ModalConfirmNfc = dynamic(
  () => import('@/components/elements/register/ModalConfirmNfc')
);

const hashTabPanels: {
  [key in ELibraryTabKey]: React.ReactNode;
} = {
  [ELibraryTabKey.Library]: <DoccenLibrary />,
  [ELibraryTabKey.Roadmap]: <></>,
};

const tabs: TabDataProps[] = [
  {
    tabId: ELibraryTabKey.Library,
    value: ELibraryTabKey.Library,
    title: 'Thư viện Doccen',
  },
  {
    tabId: ELibraryTabKey.Roadmap,
    value: ELibraryTabKey.Roadmap,
    title: 'Lộ trình',
  },
];

const Page: NextPageWithLayout<{ nfcId: string }> = ({ nfcId }) => {
  const [openModal, onToggleModal] = useToggle(!!nfcId);
  const router = useRouter();

  return (
    <>
      <Content />
      {openModal && (
        <ModalConfirmNfc
          open={openModal}
          handleClose={() => {
            onToggleModal();
            window.history.replaceState(null, '', `${router.pathname}`);
          }}
          onSucess={() => {
            router.replace(PATH_NAME.LIBRARY);
          }}
        />
      )}
    </>
  );
};

const Content = memo(function Content() {
  const { currentTab, handleChangeTab } = useTab(ELibraryTabKey.Library);
  const toast = useToast();

  return (
    <div className="bg-white">
      <div className="space-y-4 border-b border-Other/Outlinedborder-stroke px-4 pt-4">
        <Tabs
          type="uncountable"
          onSelect={(e, value) => {
            if (value === ELibraryTabKey.Roadmap) {
              toast('Tính năng đang phát triển', 'success');
              return;
            }
            handleChangeTab(e, value);
          }}
          tabs={tabs}
          selected={currentTab}
        />
      </div>
      {hashTabPanels[currentTab]}
    </div>
  );
});

Page.getLayout = (page) => {
  return <BaseLayout>{page}</BaseLayout>;
};

export default Page;

export const getServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  cookieCommons.setContext(context);
  const nfcId = context.query?.nfcId;

  const seo = JSON.parse(
    JSON.stringify(
      useSEO('Doccen Library - Thư viện Doccen', {
        description:
          'Thư viện tài liệu Y Dược, sách tham khảo, giáo trình và khuyến cáo từ các trường đại học, hiệp hội nghề nghiệp uy tín trong và ngoài nước.',
      })
    )
  );

  return {
    props: {
      seo,
      nfcId: nfcId ?? '',
    },
  };
};
